/* tslint:disable: component-class-suffix */

import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    ViewEncapsulation,
} from '@angular/core';

import {
    matDialogAnimations as animation,
} from '@angular/material/dialog';

import {
    DialogContainer,
} from '../dialog.container';


@Component({
    selector: 'thm-confirm-dialog',
    templateUrl: './confirm.container.html',
    styleUrls: ['./confirm.container.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default,
    animations: [animation.dialogContainer],
})
export class ConfirmContainer extends DialogContainer {

    @HostBinding('class.thm-confirm-dialog')
    public get classes(): boolean { return true; }

    protected get text(): string { return this.data && this.data.text || ''; }
    protected get hint(): string { return this.data && this.data.hint || ''; }

}
